import React, { useEffect, useState } from 'react'
import { Switch } from '@Components/shadcn/ui/switch'
import { Tooltip } from 'react-tooltip';
import { RootState, useAppSelector } from '@Store/store';



function AskForFollow({ index, aff_data, update_response_data, automationId }: { index: number, aff_data: any, update_response_data: (data: any) => void, automationId: string | number | undefined }) {
    const [isEditing, setIsEditing] = useState(false)
    const [editText, setEditText] = useState("")
    const [editButtonTitles, setEditButtonTitles] = useState(["", ""])


    const { user } = useAppSelector((state: RootState) => state.profile);
    const selectedIgData = useAppSelector((state: RootState) => state.igSelection.selectedIgData);


    const DEFAULTASKFORFOLLOW = {
        type: 'ask_follow',
        text: "Oh no! It seems you're not following me 👀 \n\nThis content is for the fam only 🔒\nWanna be part of the inner circle? Just hit that Follow button on my profile 😊\nOnce you're in, tap \"I'm following\" below to unlock the good stuff ✨\nLet's make it official — welcome to the crew 💛",
        buttons: [
            {
                title: "Visit Profile",
                url: `https://instagram.com/${selectedIgData?.username}`, // This will be replaced with actual profile URL
                type: "web_url" as const,
                subtype: "follow"
            },
            {
                title: "I'm following ✓",
                postback_text: `AskForFollow#${user?.user_id}#${automationId}`,
                type: "postback" as const
            }
        ]
    }


    const [followCheckMessage, setFollowCheckMessage] = useState(() => {
        // Initialize with incoming data if it has content, otherwise use defaults
        if (aff_data && aff_data.text && aff_data.buttons) {
            return aff_data
        }
        return DEFAULTASKFORFOLLOW
    })

    // Update state when aff_data changes
    useEffect(() => {
        if (aff_data && aff_data.text && aff_data.buttons) {
            // Use existing data if it has actual content
            setFollowCheckMessage(aff_data)
            setEditText(aff_data.text)
            setEditButtonTitles([
                aff_data.buttons[0].title,
                aff_data.buttons[1].title
            ])
        } else if (aff_data && aff_data.type === 'ask_follow' && !aff_data.text) {
            // If only type exists, merge with defaults and update
            const mergedData = {
                ...DEFAULTASKFORFOLLOW,
                ...aff_data
            }
            setFollowCheckMessage(mergedData)
            setEditText(mergedData.text)
            setEditButtonTitles([
                mergedData.buttons[0].title,
                mergedData.buttons[1].title
            ])
            // Update the parent with the merged data
            update_response_data(mergedData)
        }
    }, [aff_data])

    const handleEdit = () => {
        setEditText(followCheckMessage.text)
        setEditButtonTitles([
            followCheckMessage.buttons[0].title,
            followCheckMessage.buttons[1].title
        ])
        setIsEditing(true)
    }

    const handleSave = () => {
        const updatedMessage = {
            ...followCheckMessage,
            text: editText,
            buttons: [
                {
                    ...followCheckMessage.buttons[0],
                    title: editButtonTitles[0]
                },
                {
                    ...followCheckMessage.buttons[1],
                    title: editButtonTitles[1]
                }
            ]
        }
        setFollowCheckMessage(updatedMessage)
        setIsEditing(false)
        // Explicitly update parent after saving
        update_response_data(updatedMessage)
    }

    const handleCancel = () => {
        setEditText(followCheckMessage.text)
        setEditButtonTitles([
            followCheckMessage.buttons[0].title,
            followCheckMessage.buttons[1].title
        ])
        setIsEditing(false)
    }

    const handleButtonTitleChange = (index: number, value: string) => {
        const newTitles = [...editButtonTitles]
        newTitles[index] = value
        setEditButtonTitles(newTitles)
    }


    return (
        <div className="w-full rounded-lg">

            {/* Toggle Bar */}
            {/* <div className="flex items-center justify-between p-4 bg-gray-100 rounded-lg">
                <span className="text-sm font-medium text-gray-700 align-middle flex gap-1">
                    Follow Check Message
                    <button
                        className="text-gray-400 hover:text-gray-600 follow-check-message-tooltip"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                    <Tooltip anchorSelect=".follow-check-message-tooltip" place="top">
                        <span className='text-center'>The follow check message prompts users<br/> to follow your account before accessing<br/> exclusive content.</span>
                    </Tooltip>
                </span>
            </div> */}

            {/* Collapsible Content */}
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out`}
            >
                <div className=" bg-white rounded-[20px] md:p-4 p-2">
                    <div className='max-w-[400px] mx-auto rounded-[20px]  border p-6 relative'>
                        {/* Edit Button */}
                        {!isEditing && (
                            <button
                                onClick={handleEdit}
                                className="absolute flex items-center gap-1 top-1 right-1 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                                title="Edit message" >
                                Edit
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                        )}

                        {!isEditing ? (
                            <>
                                <div className="text-sm text-gray-600 whitespace-pre-wrap mb-4">
                                    {followCheckMessage?.text || ''}
                                </div>
                                <div className="space-y-2">
                                    {followCheckMessage?.buttons?.map((btn: any, idx: number) => (
                                        <div key={idx} className="py-2 px-4 border rounded-xl text-center text-sm font-medium text-[#3535d5]">
                                            {btn.title}
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Message Text
                                    </label>
                                    <textarea
                                        value={editText}
                                        onChange={(e) => setEditText(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gray-800 focus:border-gray-800 ring-none outline-none text-sm resize-none"
                                        rows={9}
                                        placeholder="Enter your follow check message..."
                                    />
                                </div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Buttons
                                </label>
                                <div>
                                    <input
                                        type="text"
                                        value={editButtonTitles[0]}
                                        maxLength={20}
                                        onChange={(e) => handleButtonTitleChange(0, e.target.value)}
                                        className="text-center w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gray-800 focus:border-gray-800 ring-none outline-none text-sm"
                                        placeholder="Enter first button text..."
                                    />
                                    <p className='text-xs text-[#3535d5] text-center mt-2'>(On clicking this user will be taken to your IG account)</p>
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        value={editButtonTitles[1]}
                                        maxLength={20}
                                        onChange={(e) => handleButtonTitleChange(1, e.target.value)}
                                        className="text-center w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gray-800 focus:border-gray-800 ring-none outline-none text-sm"
                                        placeholder="Enter second button text..."
                                    />
                                </div>
                                <div className="flex gap-2 justify-end mt-2">
                                    <button
                                        onClick={handleCancel}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSave}
                                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AskForFollow